module.exports = __webpack_public_path__ + "static/media/news.08487512.jpg";